import {SET_FB_RESPONSE} from '../actions/auth/type';

const initState = {fbResponse: null};
export default function(state = initState, action) {
    switch (action.type) {
        case SET_FB_RESPONSE:
            return {...state, fbResponse: action.payload};
        default:
            return state;
    }
}